<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              Products
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4">
            <CreateAction
              v-if="$membershipHasPermissionTo('create acc products')"
              :account-id="accountId"
              @created="fetchProducts"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div v-if="loading" class="text-center">
        <Loader />
      </div>
      <List v-else :products="products">
        <template #before-table="productListProps">
          <Search
            :action="searchProducts"
            @loading="productListProps.setLoading()"
            @loaded="productListProps.setLoading(false)"
          />
          <!-- <Filters
            :action="filterProducts"
            :filters="query.filter"
            @loading="productListProps.setLoading()"
            @loaded="productListProps.setLoading(false)"
          /> -->
          <Pagination
            :meta="meta"
            :action="fetchPage"
            @loading="productListProps.setLoading()"
            @loaded="productListProps.setLoading(false)"
          />
        </template>
        <template #after-table="productListProps">
          <Pagination
            :meta="meta"
            :action="fetchPage"
            @loading="productListProps.setLoading()"
            @loaded="productListProps.setLoading(false)"
          />
        </template>
      </List>
    </div>
  </div>
</template>

<script>
import CreateAction from './client-products/components/create-action.vue';
import Search from './client-products/components/search.vue';
// import Filters from './client-products/components/filters.vue';
import Pagination from './client-products/components/pagination.vue';
import List from './client-products/components/product-list.vue';

export default {
  components: {
    CreateAction,
    Search,
    // Filters,
    Pagination,
    List,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      meta: {},
      query: {
        page: 1,
        filter: {},
        include: 'media,accOrderLineItemsCount,accOrderLineItemsSumTotal',
      },
    };
  },
  computed: {
    products() {
      return this.$store.getters['ui/accountAccProducts/itemsByParent'](this.accountId);
    },
  },
  created() {
    this.setup();
  },
  destroyed() {
    this.$store.dispatch('ui/accountAccProducts/clearByParent', { parentId: this.accountId });
  },
  methods: {
    setLoading(loading = true) {
      this.loading = Boolean(loading);
    },
    async setup() {
      this.setLoading();

      try {
        await this.fetchProducts();
      } catch (error) {
        // code here
      } finally {
        this.setLoading(false);
      }
    },
    async fetchProducts() {
      try {
        const { search, filter = {}, ...restQuery } = this.query;
        const { meta } = await this.$store.dispatch('ui/accountAccProducts/load', {
          id: this.accountId,
          query: {
            filter: {
              ...filter,
              search,
            },
            ...restQuery,
          },
        });

        this.meta = meta;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchPage(page) {
      this.query.page = page;
      await this.fetchProducts();
    },
    async filterProducts(filter) {
      this.query.filter = { ...filter };
      this.query.page = 1;
      await this.fetchProducts();
    },
    async searchProducts(search) {
      this.query.search = search;
      this.query.page = 1;
      await this.fetchProducts();
    },
  },
  provide() {
    return {
      fetchProducts: this.fetchProducts,
    };
  },
};
</script>
